export enum SortDirection {
	Ascending = "ascending",
	Descending = "descending",
}

export type Comparator<T> = (item1: T, item2: T) => number
